<div class="dna-ss-wrap" [class.open]="isOpen" [class.disabled]="disabled">

  <div class="dna-ss-trigger" (click)="toggle()"
       cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <span class="dna-ss-value" [class.dna-ss-placeholder]="!selectedLabel">
      {{selectedLabel || placeholder}}
    </span>
    <span class="material-icons dna-ss-arrow">expand_more</span>
  </div>

</div>

<!-- Painel renderizado via CDK Overlay (portal no body) para flutuar acima de
     qualquer container com overflow:hidden e ficar sempre alinhado ao campo,
     igual ao dropdown que funciona no SSO. -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayWidth]="overlayWidth"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayPush]="true"
  (overlayOutsideClick)="onOutsideClick($event)"
  (detach)="close()">

  <div class="dna-ss-panel">
    <div class="dna-ss-search">
      <span class="material-icons">search</span>
      <input #searchInput type="text" placeholder="Pesquisar..."
        [(ngModel)]="searchTerm" (click)="$event.stopPropagation()">
    </div>
    <div class="dna-ss-list" (scroll)="$any($event.target).scrollLeft = 0">

      @if (!multiple) {
        @for (opt of filteredOptions; track opt.value) {
          <div class="dna-ss-option"
               [class.dna-ss-selected]="isSameValue(opt.value, selectedValue)"
               (click)="select(opt, $event)">
            {{opt.label}}
          </div>
        }
        @if (filteredOptions.length === 0) {
          <div class="dna-ss-empty">Nenhum resultado</div>
        }
      }

      @if (multiple) {
        <label class="dna-ss-option dna-ss-option-check" (click)="toggleAll($event)">
          <input type="checkbox" [checked]="isAllSelected" (click)="$event.stopPropagation(); toggleAll($event)">
          <span>Todos</span>
        </label>
        @for (opt of filteredOptions; track opt.value) {
          <label class="dna-ss-option dna-ss-option-check"
                 (click)="toggleOption(opt, $event)">
            <input type="checkbox" [checked]="isSelected(opt.value)" (click)="$event.stopPropagation(); toggleOption(opt, $event)">
            <span>{{opt.label}}</span>
          </label>
        }
        @if (filteredOptions.length === 0) {
          <div class="dna-ss-empty">Nenhum resultado</div>
        }
      }

    </div>
  </div>

</ng-template>
